const TYPE_NAME = {
	OperaMini: "operamini",
	iPhone: "iphone",
	iPad: "ipad",
	Android: "android",
	Blackberry: "blackberry",
	Palm: "palm",
	Windows: "windows",
	FirefoxOS: "firefox-os",
};

const TYPE_REGEX = {
	[TYPE_NAME.OperaMini]: /opera mini/i,
	[TYPE_NAME.iPhone]: /ipod|iphone/i,
	[TYPE_NAME.iPad]: /ipad/i,
	[TYPE_NAME.Android]: /android/i,
	[TYPE_NAME.Blackberry]: /blackberry/i,
	[TYPE_NAME.Palm]: /(palm|hiptop|avantgo|plucker|xiino|blazer|elaine|fennec| pre)/i,
	[TYPE_NAME.Windows]: /iris|3g_t|windows ce|opera mobi|windows phone/i,
	[TYPE_NAME.FirefoxOS]: /mozilla\/5.0 \(mobile;/i,
};

export default function getMobileType() {
	const userAgent = window && window.navigator && window.navigator.userAgent;
	return Object.values(TYPE_NAME)
		.find((name) => userAgent.match(TYPE_REGEX[name])) || TYPE_NAME.Default;
}



// WEBPACK FOOTER //
// ./src/shared/util/getMobileType.js